import { forwardRef, createElement } from 'react';

function IconDocumentError(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zM13 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5zm-1 12.91c.516 0 .935.333.935.849 0 .515-.42.848-.935.848-.516 0-.94-.333-.94-.848 0-.516.424-.849.94-.849zm0-5.978c.509 0 .883.352.917.807l.001.106-.15 3.62a.754.754 0 01-.768.736.757.757 0 01-.768-.632l-.01-.104-.135-3.62c-.022-.505.37-.913.913-.913zm2.5-5.811V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var DocumentError = /*#__PURE__*/forwardRef(IconDocumentError);

export default DocumentError;
//# sourceMappingURL=DocumentError.js.map
